import { user } from '$lib/stores/user/store';
import { get } from 'svelte/store';
import { RegistrationPathService } from '../registration-path';
import { PAGES } from '$lib/utils/constants';

export const LOGIN_EXCEPTION_HANDLER = async () => {
    return PAGES.INTERNAL.LOGIN; 
}

export const ROUTE_TO_NMHP_HANDLER= async () => {
    return PAGES.INTERNAL.HOME; 
}

export const REG_PATH_EXCEPTION_HANDLER = async () => {
    const currentUser = get(user);
    return RegistrationPathService.next(currentUser);
  };
